import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, Input, OnDestroy, Optional, Self, ViewChild, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, FormsModule, NgControl, UntypedFormControl } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NumericTextBoxModule, TextBoxComponent, TextBoxModule } from '@progress/kendo-angular-inputs';
import { ButtonVariant } from '@qpoint/buttons';
import { QPointIconModule } from '@qpoint/icons';
import { Subject } from 'rxjs';

@Component({
    selector: 'qpoint-password-input',
    templateUrl: './password-input.component.html',
    styleUrls: ['./password-input.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [
        CommonModule,
        TextBoxModule,
        FormsModule,
        NumericTextBoxModule,
        QPointIconModule,
        TranslateModule
    ]
})
export class QPointPasswordInputComponent implements AfterViewInit, OnDestroy, ControlValueAccessor {
  @ViewChild("textbox") public textbox: TextBoxComponent;

  public controlForValidation = new UntypedFormControl();
  public controlForValidationDisplayActive = false;

  constructor(@Self() @Optional() public control: NgControl) {
    if (this.control) {
      this.control.valueAccessor = this;
    }
  }

  ButtonVariant = ButtonVariant;

  /***
   * OnChange and OnTouched PlaceHolders for ngValueAccessor Callback registration
   */
  public onChange;
  public onTouched;

  public value: string = null;

  private ngUnsubscribe = new Subject<void>();

  @Input() public disabled = false;

  ngAfterViewInit(): void {
    this.textbox.input.nativeElement.type = "password";
    this.controlForValidation.addValidators(this.control?.control?.validator);
  }

  
  get asFormControl(): UntypedFormControl | null {
    return (this.control?.control as UntypedFormControl) || null;
  }

  // Should be called whenever something in the view has changed

  public registerOnChange(fn: any): void {  
    this.onChange = fn;
  }

  // Is used whenever the control receives a touch event

  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  public onTouch() {
    if(this.onTouched) {
      this.onTouched();
    }
  }

  writeValue(obj: string): void {
    this.value = obj;
  }

  public toggleVisibility(): void {
    const inputEl = this.textbox.input.nativeElement;

    if (inputEl.type === "password") {
      inputEl.type = "text";
    } else {
      inputEl.type = "password";
    }
  }

  public valueChanged(value: any) {
    this.onChange(value);
    this.writeValue(value);
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
